import React, {useState} from "react";
import {Box, Button, Column, Columns, Field, Input, Title} from "@allxsmith/bestax-bulma";


export default function NewDriver({onSave}){
    const [driver, setDriver] = useState({
        name: "",
    })
    const onChange = e => {
        let newDriver = {...driver, [e.target.name]: e.target.value}
        setDriver(newDriver);
    }
    return (
        <Box>
            <details>
                <summary><Title>Add Driver</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Field>
                        <label className="label">Name</label>
                        <Input
                            name={"name"}
                            type={"text"}
                            onChange={onChange}
                            value={driver.name}
                        />
                    </Field>
                </Column>
                <Column/>
                <Column/>
                <Column/>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={() => onSave(driver)}
                        isFullWidth
                    >
                        Create
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}